export default __webpack_public_path__ + "static/media/Pin_Job_Tech_Large.6f9c2ff6.svg";